import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=454a959e&scoped=true&"
import script from "./PerformanceChart.vue?vue&type=script&lang=js&"
export * from "./PerformanceChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a959e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('454a959e')) {
      api.createRecord('454a959e', component.options)
    } else {
      api.reload('454a959e', component.options)
    }
    module.hot.accept("./PerformanceChart.vue?vue&type=template&id=454a959e&scoped=true&", function () {
      api.rerender('454a959e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/usagedetailperformance/PerformanceChart.vue"
export default component.exports